import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ContactNexus from './pages/contact-nexus';
import InteractivePortfolioGallery from './pages/interactive-portfolio-gallery';
import ProcessLaboratory from './pages/process-laboratory';
import SkillConstellation from './pages/skill-constellation';
import NeuralNetworkVisualizer from './pages/experimental-playground';
import Homepage3DHub from './pages/3d-homepage-hub';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Homepage3DHub />} />
        <Route path="/contact-nexus" element={<ContactNexus />} />
        <Route path="/interactive-portfolio-gallery" element={<InteractivePortfolioGallery />} />
        <Route path="/process-laboratory" element={<ProcessLaboratory />} />
        <Route path="/skill-constellation" element={<SkillConstellation />} />
        <Route path="/experimental-playground" element={<NeuralNetworkVisualizer />} />
        <Route path="/3d-homepage-hub" element={<Homepage3DHub />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
